// @ts-nocheck
import defaults from 'superagent-defaults';
import Cookies from 'js-cookie';
import * as Sentry from '@sentry/react';
export default function request(forceLogin = true) {
    const superagent = defaults();
    return superagent
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json')
        .withCredentials()
        .use((request) => {
        request.on('error', (error) => {
            if (error.status === 401 && forceLogin) {
                window.location = `/account/login?next=${window.location.pathname}`;
            }
        });
    })
        .set('X-CSRFToken', Cookies.get('csrftoken'));
}
export const requestError = (err, message = 'Error loading data') => {
    Sentry.captureException(err);
    console.error(err);
};
